<template>
  <div class="component-publishtestdialog">
    <v-dialog v-model="dialog" max-width="600">
      <v-card>
        <v-card-title class="headline">
          <v-icon left color="warning">mdi-publish</v-icon>
          Pubblica la configurazione del Test
        </v-card-title>

        <v-card-text>
          <v-alert
            type="warning"
            text
            class="mb-4"
          >
            <strong>Attenzione:</strong> Stai per pubblicare la configurazione del test.
          </v-alert>

          <p>
            <strong>Vuoi procedere con la pubblicazione?</strong>
            Tutte le modifiche apportate verranno rese immediatamente disponibili
            nell'applicazione per tutti gli utenti.
          </p>

          <p class="text--secondary">
            <v-icon small left>mdi-information</v-icon>
            Questa operazione aggiornerà la configurazione del wizard di creazione preventivi.
          </p>
        </v-card-text>

        <v-card-actions>
          <v-btn color="grey" text
            :disabled="loading"
            @click="cancel">
            Annulla
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn color="success" text
            :loading="loading"
            @click="publish()">
            Pubblica
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'PublishTestDialog',

  props: ['value'],

  data: () => ({
    dialog: false,
    loading: false,
  }),

  watch: {
    value(newValue) {
      this.dialog = newValue;
    },

    dialog(newValue) {
      if (this.value !== newValue) {
        this.$emit('input', newValue);
      }
    },
  },

  methods: {
    ...mapActions('wizards', { publishTest: 'publishWizard' }),

    cancel() {
      this.dialog = false;
    },

    async publish() {
      try {
        this.loading = true;
        await this.publishTest();
        this.$emit('published');
      } catch (error) {
        console.error('Errore durante la pubblicazione:', error);
      } finally {
        this.loading = false;
        this.dialog = false;
      }
    },
  },
};
</script>
